import { ReactPlugin } from "@microsoft/applicationinsights-react-js";
import {
    ICustomProperties,
    IEventTelemetry,
    IExceptionTelemetry,
    ITelemetryItem,
} from "@microsoft/applicationinsights-web";
import { Page } from "shared/models/Page";
import pages from "shared/routing/pages";

export const trackEvent = (
    appInsightsContext: ReactPlugin,
    eventTelemetry: IEventTelemetry,
    customProperties?: ICustomProperties
) => {
    if (appInsightsContext) {
        appInsightsContext.trackEvent(eventTelemetry, customProperties);
    }
};

export const trackPageView = (appInsightsContext: ReactPlugin, name: string, uri: string) => {
    if (appInsightsContext) {
        const pageUri = uri.startsWith(window.location.origin) ? uri : `${window.location.origin}${uri}`;
        appInsightsContext.trackPageView({ name: name, uri: pageUri });
    }
};

export const mapOperationNameToDisplayName = (telemetryItem: ITelemetryItem) => {
    let pathName = "";

    if (telemetryItem?.data?.PageUrl) {
        const pageUrl = new URL(telemetryItem.data.PageUrl);
        pathName = pageUrl.pathname;
    } else if (telemetryItem?.baseData?.uri) {
        if (telemetryItem.baseData.uri.startsWith("http")) {
            const url = new URL(telemetryItem.baseData.uri);
            pathName = url.pathname;
        } else {
            pathName = telemetryItem?.baseData?.uri;
        }
    }

    const allPages = Object.entries(pages).map((i) => i[1] as Page);
    const page = allPages.find(
        (p) =>
            p.path === pathName ||
            p.path.replace(new RegExp("/:[a-zA-Z0-9]*/", "g"), "//") ===
                pathName.replace(new RegExp("/[0-9]*/", "g"), "//")
    );
    return page?.displayName ?? "Inna";
};

export const trackException = (
    appInsightsContext: ReactPlugin,
    exceptionTelemetry: IExceptionTelemetry,
    customProperties?: ICustomProperties
) => {
    if (appInsightsContext) {
        appInsightsContext.trackException(exceptionTelemetry, customProperties);
    }
};
